import {KeyboardEvent} from 'react';

export function handleKeyDown(event: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    if (event.key === 'Backspace' || event.key === 'Enter') {
        event.stopPropagation();
    }
}
